import _ from "lodash";

import Node from "./baseNode";
import * as path from "../path";

export default class StepNode extends Node {
	static get modelName() {
		return "StepNode";
	}

	constructor(k4node) {
		super(k4node);

		this.targetPath = path.normalize(k4node.child("properties/path").value());
		if (k4node.root().child(this.targetPath)) {
			this.target = path.$ref(this.targetPath);
		} else {
			// Ignore invalid paths to prevent JSON pointer errors
			this.target = null;
		}
	}

	get targetIsCommand() {
		return this.target && this.target.isCommand || this.targetPath.includes("/commands/");
	}

	get targetIsEvent() {
		return this.target && this.target.isEvent || this.targetPath.includes("/events/");
	}

	get args() {
		try {
			return JSON.parse(this.properties.args.value);
		} catch {
			return {};
		}
	}

	get hasArgs() {
		try {
			return !_.isEmpty(this.args);
		} catch {
			return false;
		}
	}
}
